<template>
  <section
    class="py-16 px-4 md:px-8 lg:px-16 bg-white relative overflow-hidden"
    :style="{ backgroundImage: `url('/images/testimonial-bg-shapes.png')`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }"
  >
    <div class="text-center mb-12">
      <h2 class="text-3xl md:text-4xl font-bold mb-4 text-gray-800">Student Say!</h2>
      <p class="text-gray-600 max-w-2xl mx-auto">
        If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.
      </p>
    </div>

    <div
      class="relative w-full overflow-hidden"
      @mouseenter="pauseAnimation"
      @mouseleave="resumeAnimation"
    >
      <div
        ref="carousel"
        class="flex space-x-6 animate-scroll"
        :style="{ animationPlayState: animationState }"
      >
        <div
          v-for="(testimonial, index) in testimonials"
          :key="index"
          class="flex-shrink-0 w-80 md:w-96 bg-white rounded-lg shadow-md pt-20 pb-6 px-10 cursor-pointer text-center relative transform transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
        >
          <div
            class="absolute -top-12 left-1/2 -translate-x-1/2 w-32 h-32 rounded-md overflow-hidden flex items-center justify-center"
            :style="{ border: `5px solid ${testimonial.borderColor}` }"
          >
            <img :src="testimonial.image" :alt="testimonial.name" class="w-full h-full object-cover" />
          </div>
          <h3 class="text-lg font-semibold mb-1 text-gray-800">{{ testimonial.name }}</h3>
          <p class="text-sm text-[#FDB813] mb-3">{{ testimonial.title }}</p>
          <p class="text-gray-600 text-sm leading-relaxed">"{{ testimonial.quote }}"</p>
        </div>

        <div
          v-for="(testimonial, index) in testimonials"
          :key="'duplicate-' + index"
          class="flex-shrink-0 w-80 md:w-96 bg-white rounded-lg shadow-md pt-20 pb-6 px-6 text-center relative transform transition-all duration-300 hover:scale-[1.02] hover:shadow-lg"
        >
          <div
            class="absolute -top-12 left-1/2 -translate-x-1/2 w-32 h-32 rounded-md overflow-hidden flex items-center justify-center"
            :style="{ border: `5px solid ${testimonial.borderColor}` }"
          >
            <img :src="testimonial.image" :alt="testimonial.name" class="w-full h-full object-cover" />
          </div>
          <h3 class="text-lg font-semibold mb-1 text-gray-800">{{ testimonial.name }}</h3>
          <p class="text-sm text-[#FDB813] mb-3">{{ testimonial.title }}</p>
          <p class="text-gray-600 text-sm leading-relaxed">"{{ testimonial.quote }}"</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useThemeStore } from '../../stores/themeStore';

const themeStore = useThemeStore();

const carousel = ref(null);
const animationState = ref('running');

// Null-safe computed value
const testimonials = computed(() => themeStore?.theme?.testimonialsData || []);

const pauseAnimation = () => {
  animationState.value = 'paused';
};

const resumeAnimation = () => {
  animationState.value = 'running';
};

onMounted(() => {
  if (testimonials.value.length > 0 && carousel.value) {
    const totalWidth = testimonials.value.length * 320;
    const duplicateWidth = totalWidth * 2;
    carousel.value.style.width = `${duplicateWidth}px`;
    carousel.value.style.animationDuration = `${totalWidth / 30}s`;
  }
});

onUnmounted(() => {
  // Cleanup if needed
});
</script>

<style scoped>
.animate-scroll {
  animation: scroll 20s linear infinite;
}
@keyframes scroll {
  0% { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
</style>
